import React, { FC, useEffect } from 'react';
import {
  Block as BlockModel,
  emptyStudyGuideBlockContent,
} from '../../../../config/api/models/Block';
import { usePagesByType } from '../../hooks';
import { styled } from '@material-ui/core';
import { isEqual } from 'lodash';
import { BlocksList } from '../TrajectoryDetail/BlocksList';
import { fetchBlocks } from '../../../shared/slices/blocks/api/blocks';
import { useAppDispatch, useAppSelector } from '../../../shared/hooks/useAppDispatch';
import { setPageWidth } from 'src/modules/shared/slices/privatePageSettings/entity/privatePageSettingsSlice';

const BlocksWrapper = styled('div')({
  marginBottom: '3rem',
});

export const TrajectoryStudyGuidePageView: FC = () => {
  // hooks
  const pages = usePagesByType('study_guide');
  const dispatch = useAppDispatch();

  // redux
  const blocks = useAppSelector((state) => state.blocks.blocks);
  const loading = useAppSelector((state) => state.blocks.loading);
  const notes = useAppSelector((state) => state.blockNotes.blockNotes);

  useEffect(() => {
    dispatch(setPageWidth(100));
    return () => {
      dispatch(setPageWidth());
    };
  }, [dispatch]);

  useEffect(() => {
    if (blocks == null) return;

    setTimeout(() => {
      // @ts-ignore
      //com.wiris.js.JsPluginViewer.parseDocument(true);
    }, 200);
  }, [blocks]);

  const pageId = React.useMemo(
    () => (pages.data && pages.data.length > 0 ? pages.data[0].id : undefined),
    [pages.data]
  );

  useEffect(() => {
    if (pageId) {
      dispatch(fetchBlocks(pageId));
    }
  }, [pageId, dispatch]);

  const filteredBlocks = React.useMemo(() => {
    if (!blocks || blocks?.length === 0) return [];
    return blocks
      .filter((block: BlockModel) => !isEqual(block.content, emptyStudyGuideBlockContent))
      .map((item: BlockModel) => {
        const parent = item.parent_id ?? item.id;
        const note = notes?.find((note) => note.blockId === parent);
        return { ...item, note };
      });
  }, [blocks, notes]);

  if (!blocks || blocks?.length === 0) return null;

  return !!pageId && filteredBlocks.length > 0 && !loading ? (
    <>
      <BlocksWrapper>
        <BlocksList
          pageId={pageId}
          pageType="study_guide"
          readOnly
          blocks={filteredBlocks}
          onUpdate={() => {}}
        />
      </BlocksWrapper>
    </>
  ) : null;
};
